import { Link } from 'react-router-dom';
import React from 'react';
import { Button } from 'src/components/ui/button';
import { PATH_DASHBOARD } from 'src/constants/spa-routes';
import { LoaderWrapper } from 'src/components/LoaderWrapper/LoaderWrapper';
import { Skeleton } from 'src/components/ui/skeleton';
import { RepliesLine } from 'src/pages/ControlDeskPage/RepliesBalanceSection/RepliesLine';
import { useGetAccountsQuery } from 'src/services/accountsService';
import { useAppSelector } from 'src/store';
import { clsx } from 'clsx';
import { WarningPopover } from 'src/components/WarningPopower/WarningPopover';
import { useGetUsersMeQuery } from 'src/services/usersService';
import { SUBSCRIPTION_ACCESS_ROLES } from 'src/constants/roles';

export const TrialBanner = () => {
  const { data: account, isFetching: accountIsFetching } = useGetAccountsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const { data: userInfo } = useGetUsersMeQuery();
  const { isInactivePlan } = useAppSelector((s) => s.planSlice);
  const isEmpty = !Boolean(Object.keys(account?.general_plan || {})?.length);
  const generalPlan = account?.general_plan;
  const disabledButton = !SUBSCRIPTION_ACCESS_ROLES.includes(userInfo?.role);

  return (
    <div
      className={clsx(
        isInactivePlan ? 'bg-[#FCF2F5] border-[#C11A4526]' : 'border-[#389D6140] bg-[#E4FFEC]',
        'w-full flex flex-row items-center justify-between py-5 px-7 border rounded-sm-5',
      )}
    >
      <div className={'flex flex-col gap-1 w-7/12'}>
        <p
          className={clsx(
            isInactivePlan ? 'text-[#C11A45]' : 'text-[#0E873F]',
            'text-xl font-bold',
          )}
        >
          {isInactivePlan ? 'Your Trial Is Over' : 'Your Trial Is Active'}
        </p>
        <div className="w-full">
          {isEmpty ? (
            <div className="empty-message w-full">
              <LoaderWrapper
                loader={<Skeleton className="w-full h-2" />}
                isLoading={accountIsFetching}
              >
                <p className="opacity-70 font-semibold text-base text-ebony">
                  No active subscription.
                </p>
              </LoaderWrapper>
            </div>
          ) : isInactivePlan ? (
            <p className={'text-sm font-medium text-[#C11A45B2]'}>You've used all free replies.</p>
          ) : (
            <RepliesLine
              generalPlan={generalPlan}
              color={'#389D61'}
              progressLineClassName="!bg-[#389D61]"
              progressLineContainerClassName="bg-[#389D6126]"
            />
          )}
        </div>
      </div>
      <div className={'flex flex-col relative'}>
        <Link
          className={clsx(disabledButton && 'opacity-50 pointer-events-none')}
          to={PATH_DASHBOARD.SUBSCRIPTION}
        >
          <Button variant={isInactivePlan ? 'red' : 'green'} size="xl">
            <p className="font-bold text-sm">Launch Subscription</p>
          </Button>
        </Link>
        {disabledButton && (
          <WarningPopover triggerClassName="absolute -right-2 -top-2" fill="black" />
        )}
      </div>
    </div>
  );
};
